import React, { lazy } from 'react';
import { RouteComponentProps } from '@reach/router';
import { endpoints } from '../../endpoints.config';
import Category from '../../components/Category';
import { CrudItems } from 'components/Category/CrudMenu';
import { useTranslation } from 'react-i18next';

// Icons
import Update from '../../assets/Cat-Entity/Icon_Action_02.png';

const ApprovalType = lazy(() => import('./ManageApprovalType'));

// Define the url for the table's data endpoint.
const url = endpoints.approvalTypes.list;

// Define which column on the table represents each row's ID.
const idColumn: keyof ApprovalsListData = 'approvalTypes__Id';

//Define the data structure for table
export type ApprovalsListData = {
    approvalTypes__Id: string;
    approvalTypes__Name: string;
    approvalTypes__NumberOfApprovers: number;
    approvalTypes__bSuppressed: boolean;
    approvalTypes__AddedBy: string;
};

const getCrudItems = (t: (key: string, options?: any) => any): CrudItems<ApprovalsListData> => [
    {
        icon: Update,
        imgAltText: t('update', { ns: 'common' }),
        title: t('assignUsers'),
        menuCode: 'UPDATE',
        showInMultiSelect: false,
        content: (onDone, selectedData, menu) => (
            <ApprovalType
                selectedData={selectedData}
                onDone={onDone}
                idFromRowOption={menu.selectedId}
                actionType="edit"
            />
        ),
        inRightPanel: true,
        isDisabled: false,
    },
];

const approvalNameKeys: Record<string, string> = {
    'reverse inbound external transfers': 'reverseExternalTransfers',
    'reverse incoming external transfers': 'reverseExternalTransfers',
    'pull ach': 'achPull',
    'ach pull': 'achPull',
    'create payee': 'createBeneficiary',
    'create beneficiary': 'createBeneficiary',
    'create external transfer': 'createExternalTransfer',
    'cancel customer transaction': 'cancelClientTransaction',
    'cancel client transaction': 'cancelClientTransaction',
    'asset exchange': 'assetExchange',
    'enable cryptocurrencies for dda accounts': 'enableCryptoForDda',
};

export interface BusinessUsersProps {}

type Props = BusinessUsersProps & RouteComponentProps;

function ManageApprovalTypes(props: Props) {
    const { t } = useTranslation('approvals');
    return (
        <Category<ApprovalsListData>
            location={props.location}
            contentTitle={t('delegatedApprovers')}
            noun={t('approvalTypes')}
            idColumn={idColumn}
            listEndpointUrl={url}
            primitiveFormatters={{
                string: (s: string) => {
                    const key = approvalNameKeys[s.toLowerCase()];
                    return <span>{key ? t(key) : s}</span>;
                },
            }}
            crudComponents={getCrudItems(t)}
            hiddenColumns={[idColumn]}
            noAddBtn
            classname="listsCatTable"
            emptyTableLabel={t('noApprovalsFound', { ns: 'common' })}
        />
    );
}

export default ManageApprovalTypes;
